import { createHook } from 'react-sweet-state';
import tourStore from "../store/tour";

const useTourState = createHook(tourStore);

export default useTourState;